import EmploymentInfoScreen from 'features/advance/screens/registration/EmploymentInfo/EmploymentInfo';
import React from 'react';

export default function EmploymentInfoPage() {
  return <EmploymentInfoScreen />;
}
